export function formatHours(value: number | null | undefined): string {
  if (value === null || value === undefined) {
    return '0';
  }

  const rounded = Math.round(value * 10) / 10;
  return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
}
